module.exports = __webpack_public_path__ + "img/img-auth-sideimg3.34bae183.png";